module.exports = __webpack_public_path__ + "static/blue-ocean-strategy-expanded-edition-07bf4eb0401a57946e038b3dd8a70fad.jpg";